export class ProduktSearchTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        sokProdukt: "Sök produkt",
        skapaNyProdukt: "Skapa ny produkt"
    };
}
